// src/pages/Admin.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, Package, ShieldCheck, ShoppingBag, MessageSquare } from "lucide-react";

const Admin = () => {
  const navigate = useNavigate();

  const cards = [
    {
      id: "users",
      title: "User",
      icon: Users,
      // VIOLET THEME (User Management)
      containerBg: "bg-[#EADDFF]", 
      iconColor: "text-[#21005D]",
      buttonBg: "bg-[#6750A4]", // M3 Primary Violet
      borderColor: "border-[#D0BCFF]",
      hoverBg: "hover:bg-[#F3EDFF]",
      onClick: () => navigate("/AdminUser"),
    },
    {
      id: "products",
      title: "Produk",
      icon: Package,
      // AMBER/ORANGE THEME (Product Management)
      containerBg: "bg-[#FFDFB3]", 
      iconColor: "text-[#291800]",
      buttonBg: "bg-[#8B5000]", // M3 Primary Orange/Bronze
      borderColor: "border-[#FFCC99]",
      hoverBg: "hover:bg-[#FFF8F1]",
      onClick: () => navigate("/AdminProduct"),
    },
    {
      id: "orders",
      title: "Pesanan",
      icon: ShoppingBag,
      // TEAL/GREEN THEME (Order Management)
      containerBg: "bg-[#C6F6D5]", 
      iconColor: "text-[#064E3B]",
      buttonBg: "bg-[#059669]", // M3 Primary Green/Teal
      borderColor: "border-[#A7F3D0]",
      hoverBg: "hover:bg-[#F0FFF4]",
      onClick: () => navigate("/AdminOrder"),
    },
    {
      id: "messages",
      title: "Pesan",
      icon: MessageSquare,
      // INDIGO/PURPLE THEME (Messaging/Admin Communication)
      containerBg: "bg-[#E8EAF6]", 
      iconColor: "text-[#1A237E]",
      buttonBg: "bg-[#3F51B5]", // M3 Indigo
      borderColor: "border-[#C5CAE9]",
      hoverBg: "hover:bg-[#F3F4F8]",
      onClick: () => navigate("/AdminMessage"),
    },
  ];

  return (
    <div className="min-h-screen bg-[#FEF7FF] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        
        <header className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#E8DEF8] text-[#1D192B] mb-4 shadow-sm">
            <ShieldCheck size={32} />
          </div>
          <h1 className="text-4xl font-semibold text-[#1C1B1F] tracking-tight">
            Admin Dashboard
          </h1>
        </header>

        <main className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map(({ id, title, icon: Icon, containerBg, iconColor, buttonBg, borderColor, hoverBg, onClick }) => (
            <div
              key={id}
              onClick={onClick}
              className={`group flex flex-col items-center bg-white rounded-[32px] p-8 
              shadow-[0_1px_3px_1px_rgba(0,0,0,0.15)] hover:shadow-[0_4px_12px_4px_rgba(0,0,0,0.2)] 
              transition-all duration-300 cursor-pointer border-2 ${borderColor} ${hoverBg}`}
            >
              {/* Icon & Text Container */}
              <div className={`flex items-center justify-center gap-3 w-full h-16 rounded-[24px] mb-8 transition-transform group-hover:scale-105 ${containerBg} ${iconColor}`}>
                <Icon size={28} />
                <span className="text-lg font-bold tracking-wide uppercase">{title}</span>
              </div>

              {/* M3 Primary Button */}
              <button
                className={`w-full py-4 rounded-full text-white text-base font-semibold tracking-wide shadow-md active:scale-95 transition-all ${buttonBg}`}
              >
                Open
              </button>
            </div>
          ))}
        </main>
      </div>
    </div>
  );
};

export default Admin;